var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_118_416",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_118_416",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwUlEQVR4nO2cQW7CMBQF/5nyFuFmdNcue9lWuYG7SSSEgBIK/f/ZM2sW8YytBDtKBAAAAAAAAAAAAAAAANjyFhFz+DOvY7HiIyJaRCwRcQhfFBHf61g+w0x+M4+gE/nNJcK5fNcIuiC/fIRr8t0i6Ib8shHefrng0wiVb8zzeo33jKXUjXmKiK8dEQ6mM79VnkjOEeQu3zmCepHvGEG9yXeKoF7lO0RQ7/IrR9Ao8itG0GjyK0XQqPIrRNDo8jMjCPl5EYT8vAhCfl4EIT8vgpCfF0HIz4sg5OdFEPLzIgj5eeeyy87fdvsPN3MlNOTXjrAw8/MiLMjPWwkL8vMiLMh/LtrxqLln2wJeIJ8IBeQ3VkK+/EaEfPmNCPuZ2YrIQw9srFV45aUL9IddTSIkyt8gwoPoifv5REiUv0GEO9ELT7KIkCh/gwhX+M8z3IlH1Dz5G0RYyXx7YRp9JVR4dWQaNUIF+cNGqCR/uAgV5Q8TobL87iM4yO82gpP87iI4yu8mgrP8LiLwybICHE1n/iMr4T2KcjSXf0+EsvKvRXCTfytCefnnEVzlX4pgI3+Dj3cDAAAAAAAAAAAAAABApPMDku+sSq/QIeEAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiply);
export default __webpack_public_path__ + "static/media/multiply.54b56f67683494e0fa6d3b16cf0c24b4.svg";
export { ForwardRef as ReactComponent };